import { format } from "rut.js";
import AccionesCompania from "../components/accionesCompania";
import { companiaSeguro } from "../models/companiaSeguro";
import { columns } from "../../../../dtos/columns";

interface IProps {
    control: any;
    setCompaniaEditar: React.Dispatch<React.SetStateAction<companiaSeguro | undefined>>;
    setModalDetalle: React.Dispatch<React.SetStateAction<boolean>>;
}

export function useColumns({ control, setCompaniaEditar, setModalDetalle }: IProps) {

    const COLUMNS: columns<companiaSeguro>[] = [
        {
            name: 'Acciones',
            selector: (row) => '',
            cell: (row) =>
                <AccionesCompania
                    companiaSeguro={row}
                    control={control}
                    setCompaniaEditar={setCompaniaEditar}
                    setModalDetalle={setModalDetalle}
                />,
            allowOverflow: true,
            button: true,
            export: false,
            alling: 'center'
        },
        {
            name: 'RUT',
            selector: (row) =>
                format(row.rut),
            sortable: true,
            sortField: 'rut',
            wrap: true,
            export: true
        },
        {
            name: 'Nombre',
            selector: (row) =>
                row.nombre,
            sortable: true,
            sortField: 'nombre',
            wrap: true,
            export: true
        },
    ]

    return { COLUMNS };
}